import { createErrorReporter } from '@allgen/error'
import { API_BASE_URL } from './constants'
import { setDomTranslationGuardObserver } from './domTranslationGuard'
import { useAuthStore } from '@/stores/authStore'

/**
 * 전역 에러 리포터 (Sentry-lite). 인증된 사용자의 미처리 에러를
 * POST /error-reports 로 보내 어드민(/admin/errors)에서 디버깅한다.
 * 캡처/유량제어/전송 로직은 공통 패키지 @allgen/error (../allgen-error) 소관.
 */
export const errorReporter = createErrorReporter({
  endpoint: `${API_BASE_URL}/error-reports`,
  buildId: __BUILD_ID__,
  isEnabled: () => useAuthStore.getState().isAuthenticated,
  getRoute: () => window.location.pathname,
  // 크로스오리진 마스킹된 'Script error.' (출처가 가려져 stack/위치가 없는 불투명 이벤트,
  // 주로 인앱 웹뷰·번역기 주입 스크립트)는 진단 정보가 없는 환경 노이즈이므로 전송하지 않는다.
  beforeSend: (payload) => (payload.context?.opaque === true ? null : payload),
})

const GUARD_CRUMB_THROTTLE_MS = 10_000
let lastGuardCrumbAt = 0

export function installErrorReporter(): void {
  errorReporter.install()

  // 브라우저 자동 번역 개입의 표식 — NotFoundError 계열 리포트의 원인 판별용
  setDomTranslationGuardObserver(() => {
    const now = Date.now()
    if (now - lastGuardCrumbAt < GUARD_CRUMB_THROTTLE_MS) return
    lastGuardCrumbAt = now
    errorReporter.addBreadcrumb({
      type: 'custom',
      message: 'domTranslationGuard intercepted translator DOM mutation',
    })
  })

  // 미인증 상태에서 쌓인 리포트를 로그인 직후 전송
  useAuthStore.subscribe((state, prev) => {
    if (state.isAuthenticated && !prev.isAuthenticated) {
      errorReporter.flush()
    }
  })
}
